import type { TCheckboxSizes } from '../../types'
import * as Comp from './checkbox.label.styles'

type TCheckboxLabelProps = {
  children: string
  size?: TCheckboxSizes
  error?: boolean
  disabled?: boolean
  readOnly?: boolean
  testID?: string
}

export function CheckboxLabel({
  children,
  size,
  error,
  disabled,
  readOnly,
  testID,
}: TCheckboxLabelProps) {
  const componentProperties = {
    size,
    hasError: !!error,
    hasDisabled: !!disabled,
    hasReadOnly: !!readOnly && !disabled,
  }

  return (
    <Comp.Label testID={testID} {...componentProperties} numberOfLines={4}>
      {children}
    </Comp.Label>
  )
}
